/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link, useParams } from 'react-router-dom';
import Pagination from "react-js-pagination";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { timestampFormatter } from "../../utils/utils";

const SleepSessionDataList = () => {

    const { encodedUuid, encodedUserId } = useParams();
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [records, setData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [page, setPage] = useState(1);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [displayFromDate, setDisplayFromDate] = useState("");
    const [displayToDate, setDisplayToDate] = useState("");
    const [searchValue, setSearchValue] = useState('');

    const navigate = useNavigate();

    const decodedUuid = encodedUuid ? atob(encodedUuid) : '';
    const decodedUserId = encodedUserId ? atob(encodedUserId) : '';

    useEffect(() => {
        refreshToken();
        setName('Sleep Session Details');
    }, []);

    useEffect(() => {
        getData('1', '', '', '');
    }, []);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        } catch (error) {
            console.log(error.response);
            if (error.response) {
                navigate("/");
                window.location.reload();
            }
        }
    };

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const getData = async (page, fromDate, toDate, search) => {
        setPopupOpen(true);
        const queryParams = new URLSearchParams({
            page,
            limit: 20,
            from_date: fromDate,
            to_date: toDate,
            search,
            ...(decodedUuid && { uuid: decodedUuid }),
            ...(decodedUserId && { user_id: decodedUserId }),
        });
        const response = await axiosJWT.get(
            `${baseUrl}/admin/api/sleep-session-details?${queryParams.toString()}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setPopupOpen(false);
        setData(response.data.data);
        setTotalItem(response.data.totalItem);
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
        getData(pageNumber, fromDate, toDate, searchValue);
    };

    const handleFromDate = (date) => {
        if (!date) { setFromDate(''); setDisplayFromDate(''); return; }
        const formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
        setFromDate(formattedDate);
        setDisplayFromDate(date);
    };

    const handleToDate = (date) => {
        if (!date) { setToDate(''); setDisplayToDate(''); return; }
        const formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
        setToDate(formattedDate);
        setDisplayToDate(date);
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleSearchSubmit = () => {
        setPage(1);
        getData(1, fromDate, toDate, searchValue);
    };

    const clearFilter = () => {
        setFromDate('');
        setDisplayFromDate('');
        setToDate('');
        setDisplayToDate('');
        setSearchValue('');
        setPage(1);
        getData(1, '', '', '');
    };

    return (
        <div className="panelbox">
            <Navbar />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && <Loader />}
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Sleep Session Details</h1>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="addnew-button">
                                <Link to="/user-sleep-sessions"><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>

                    <div className="row numberboxes">
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Records</h3>
                                <p>{totalItem}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 order-filter transection-filter">
                            <div className="boxinput">
                                <input
                                    className="search-leave satff-listing-page-search"
                                    type="text"
                                    name="search"
                                    placeholder="Search by name or email"
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                />
                                <DatePicker
                                    selected={displayFromDate}
                                    onChange={handleFromDate}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="From Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayToDate}
                                    onChange={handleToDate}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="To Date"
                                    className="end-date"
                                />
                                <button className="search-btn" onClick={handleSearchSubmit}>Search</button>
                                {(fromDate || toDate || searchValue) && (
                                    <button type="button" className="search-btn clear-btn" onClick={clearFilter}>Clear</button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table className="table is-striped is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>UUID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Unit</th>
                                            <th>Value</th>
                                            <th>Platform</th>
                                            <th>Data Type</th>
                                            <th>Date From (UTC)</th>
                                            <th>Date To (UTC)</th>
                                            <th>Device ID</th>
                                            <th>FireStore User ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {records && records.map((row, index) => (
                                            <tr key={index}>
                                                <td data-label="No">{(page - 1) * 20 + index + 1}</td>
                                                <td data-label="UUID" style={{ maxWidth: '140px', wordBreak: 'break-all', fontSize: '12px' }}>{row.uuid}</td>
                                                <td data-label="Name">{row.name}</td>
                                                <td data-label="Email">{row.email}</td>
                                                <td data-label="Unit">{row.unit}</td>
                                                <td data-label="Value">{row.value}</td>
                                                <td data-label="Platform">{row.platform}</td>
                                                <td data-label="Data Type">{row.data_type}</td>
                                                <td data-label="Date From (UTC)">{row.date_from ? timestampFormatter(row.date_from) : '-'}</td>
                                                <td data-label="Date To (UTC)">{row.date_to ? timestampFormatter(row.date_to) : '-'}</td>
                                                <td data-label="Device ID" style={{ maxWidth: '120px', wordBreak: 'break-all', fontSize: '12px' }}>{row.device_id || '-'}</td>
                                                <td data-label="FireStore User ID" style={{ maxWidth: '120px', wordBreak: 'break-all', fontSize: '12px' }}>{row.fire_store_user_id || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {totalItem > 20 && (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={20}
                                        totalItemsCount={totalItem}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange.bind(this)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SleepSessionDataList;
